/**
 * FactoryJourneyObservability (AJIP-16.02.009 · §27)
 * ---------------------------------------------------------------------
 * Minimum operational event kinds for factory journey engineering
 * verification. Events carry audit-safe payloads only — no secrets,
 * no raw evidence, no unsupported trust conclusions (§27).
 *
 * Namespaced FACTORY_JOURNEY_* for cross-Journey stability (P2-03).
 */

const FACTORY_JOURNEY_EVENTS = Object.freeze({
  FACTORY_JOURNEY_REGISTRATION_CONFIRMED: 'FACTORY_JOURNEY_REGISTRATION_CONFIRMED',
  FACTORY_JOURNEY_DISCOVERED: 'FACTORY_JOURNEY_DISCOVERED',
  FACTORY_JOURNEY_ELIGIBILITY_EVALUATED: 'FACTORY_JOURNEY_ELIGIBILITY_EVALUATED',
  FACTORY_JOURNEY_OWNERSHIP_EVALUATED: 'FACTORY_JOURNEY_OWNERSHIP_EVALUATED',
  FACTORY_JOURNEY_RESOLUTION_DECIDED: 'FACTORY_JOURNEY_RESOLUTION_DECIDED',
  FACTORY_JOURNEY_ACTIVATION_ATTEMPTED: 'FACTORY_JOURNEY_ACTIVATION_ATTEMPTED',
  FACTORY_JOURNEY_ACTIVATION_ACCEPTED: 'FACTORY_JOURNEY_ACTIVATION_ACCEPTED',
  FACTORY_JOURNEY_ACTIVATION_DENIED: 'FACTORY_JOURNEY_ACTIVATION_DENIED',
  FACTORY_JOURNEY_STAGE_COMMAND_ACCEPTED: 'FACTORY_JOURNEY_STAGE_COMMAND_ACCEPTED',
  FACTORY_JOURNEY_STAGE_COMMAND_REJECTED: 'FACTORY_JOURNEY_STAGE_COMMAND_REJECTED',
  FACTORY_JOURNEY_STAGE_RETURNED_FOR_CORRECTION: 'FACTORY_JOURNEY_STAGE_RETURNED_FOR_CORRECTION',
  FACTORY_JOURNEY_RESUMED: 'FACTORY_JOURNEY_RESUMED',
  FACTORY_JOURNEY_COMPLETED: 'FACTORY_JOURNEY_COMPLETED',
  FACTORY_JOURNEY_PERSISTENCE_FAILURE: 'FACTORY_JOURNEY_PERSISTENCE_FAILURE',
});
const ALL_FACTORY_JOURNEY_EVENTS = Object.freeze(Object.values(FACTORY_JOURNEY_EVENTS));

class FactoryJourneyObservability {
  constructor() {
    this._handlers = new Map();
    for (const k of ALL_FACTORY_JOURNEY_EVENTS) this._handlers.set(k, new Set());
    this._enabled = true;
  }
  on(kind, handler) {
    if (!ALL_FACTORY_JOURNEY_EVENTS.includes(kind) || typeof handler !== 'function') return () => {};
    this._handlers.get(kind).add(handler);
    return () => this._handlers.get(kind).delete(handler);
  }
  emit(kind, payload) {
    if (!this._enabled || !ALL_FACTORY_JOURNEY_EVENTS.includes(kind)) return 0;
    let count = 0;
    for (const h of this._handlers.get(kind)) {
      try { h(Object.freeze({ event: kind, at: Date.now(), payload })); count += 1; } catch (_e) { /* isolate */ }
    }
    return count;
  }
  listenerCount(kind) { return this._handlers.has(kind) ? this._handlers.get(kind).size : 0; }
}

export {
  FACTORY_JOURNEY_EVENTS,
  ALL_FACTORY_JOURNEY_EVENTS,
  FactoryJourneyObservability,
};
